/**
 * @voltxampere/ui — PC817 generic optocoupler (Sprint 44-4, placeholder)
 *
 * PLACEHOLDER. En yaygın 4-pin DIP phototransistor opto — beginner
 * Arduino/ESP kit'lerinde yaygın. JLCPCB/LCSC stok paritesi yüksek.
 *
 * Reference: Sharp PC817 — DIP-4. V_F = 1.2 V, V_R = 6 V, I_F = 50 mA,
 * V_(BR)CEO = 35 V, CTR = 50% (typical). Genel amaçlı izolasyon —
 * AC mains zero-cross detector, MCU-relay drive, level shifter.
 *
 * Engine zero-diff invariant honored — canonical `led` engine type
 * via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { led } from "../led.js";
export const optoPc817 = {
    id: "pc817",
    nameTr: "PC817 (Opto Sharp, DIP-4, CTR 50%, placeholder)",
    nameEn: "PC817 (Opto Sharp, DIP-4, CTR 50%, placeholder)",
    shortcut: "D",
    category: "active",
    viewBox: led.viewBox,
    terminals: led.terminals,
    defaultLabel: "U",
    defaultValue: "PC817",
    schemaType: "led",
    defaultParams: { saturationCurrent: 1e-12, ideality: 2 },
    renderSVG: () => led.renderSVG(),
};
//# sourceMappingURL=opto-pc817.js.map